import { FieldValidator } from './field-validator'

export class NotBlankGenericFieldValidator implements FieldValidator<string> {
    constructor(private errorMessage = 'cannot be blank') {}

    validate(text: string, fieldName: string): Promise<string> {
        return new Promise((resolve, reject) => {
            if (text === undefined || text === '' || text === null) {
                reject(`${fieldName} ${this.errorMessage}`)
            } else {
                resolve('')
            }
        })
    }
}
